/**
 * FounderStory — editorial founder note for the public landing page.
 *
 * Copy is verbatim per the Founder Story brief. Layout is typography-led:
 * warm ivory background, midnight navy body, selective gold accents,
 * generous whitespace, comfortable reading width, no product-feature
 * cards, no stock imagery. Four sentences receive visual emphasis via
 * `.v-founder-mark` — deliberately restrained so the whole section
 * doesn't over-bold.
 */
export default function FounderStory() {
    return (
        <section id="founder-story" data-testid="founder-story"
                 className="v-founder">
            <div className="v-founder-inner">
                <div className="v-founder-eyebrow">
                    <span className="v-founder-dot" />
                    FOUNDER STORY
                </div>

                <h2 className="v-founder-headline">
                    One financial life. Too many places. That became VAULT.
                </h2>

                <div className="v-founder-body">
                    <p>
                        Over the years, life became more complex — more cards,
                        bank accounts, investments, subscriptions, insurance,
                        documents, assets, liabilities and responsibilities.
                    </p>

                    <p className="v-founder-mark">
                        Nothing was really missing. The information was there.
                    </p>

                    <p className="v-founder-mark">
                        It was just everywhere.
                    </p>

                    <p>
                        Some of it lived in apps. Some in emails. Some in
                        spreadsheets and folders. And, far too often, the most
                        important things were simply being remembered in my head.
                    </p>

                    <p className="v-founder-mark">
                        I realised I didn&rsquo;t need another budgeting app.
                    </p>

                    <p>
                        I needed one place I could trust to bring my entire
                        financial life together — clearly, simply and in a way
                        that made sense to me.
                    </p>

                    <p>
                        A place where I could see what I have, what I owe,
                        what&rsquo;s coming up, what needs attention — and what
                        I might otherwise forget.
                    </p>

                    <p className="v-founder-pull">
                        &ldquo;Nothing was really missing. It was just everywhere.&rdquo;
                    </p>

                    <p>
                        That personal need became VAULT. I started building it
                        for myself. But the more I worked on it, the more I
                        realised this wasn&rsquo;t just my problem.
                    </p>

                    <p className="v-founder-mark">
                        Most of us don&rsquo;t need more financial apps.
                        We need less financial clutter.
                    </p>

                    <p>That is what I want VAULT to help solve.</p>
                </div>

                <div className="v-founder-close">
                    Your financial life. <span className="v-gold">Organised.</span>
                </div>

                <div className="v-founder-signoff">
                    <div className="v-founder-signoff-name">— PD</div>
                    <div className="v-founder-signoff-role">Founder, VAULT by PD</div>
                </div>
            </div>
        </section>
    );
}
